<!-- INPUT (será usado pelo componente pai, não precisa renderizar aqui) -->

<!-- LISTA DE RESULTADOS DA BUSCA -->
<div class="flex-1 min-h-0 mt-2 w-full overflow-auto bg-gray-100 rounded-md" *ngIf="searchResults.length > 0">
  <div class="p-2">
    <p class="text-sm font-semibold text-gray-700 mb-2">Resultados da busca ({{ searchResults.length }})</p>
    <div class="space-y-1">
      <div 
        *ngFor="let customer of searchResults; let i = index"
        (click)="selectCustomerFromList(customer)"
        [ngClass]="{
          'bg-orange-500 text-white': selectedCustomerIndex === i,
          'bg-white hover:bg-orange-50': selectedCustomerIndex !== i
        }"
        class="p-2 rounded cursor-pointer border border-gray-200 transition-colors">
        <div class="flex flex-col">
          <span class="font-semibold text-sm">{{ customer.fullName }}</span>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs" [ngClass]="{'text-orange-100': selectedCustomerIndex === i, 'text-gray-600': selectedCustomerIndex !== i}">
              CPF: {{ customer.cpf }} | {{ customer.city || 'Sem cidade' }}
            </span>
            <span class="text-xs" [ngClass]="{'text-orange-100': selectedCustomerIndex === i, 'text-gray-600': selectedCustomerIndex !== i}">
              {{ customer.phone || customer.whatsApp || 'Sem contato' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mensagem quando não há resultados -->
<div class="flex flex-col justify-center h-full text-center text-gray-500 py-8" *ngIf="searchResults.length === 0 && !isSearching">
  <p>Digite pelo menos 3 caracteres para buscar clientes</p>
</div>

<!-- Loading -->
<div class="flex flex-col justify-center h-full text-center text-gray-500 py-8" *ngIf="isSearching">
  <p>Buscando clientes...</p>
</div>

